export const UNASSIGNED_COLUMN = -1;

/**
 * Assigns each item to a column once, in source order, without moving earlier items.
 * Unassigned items wait until all previous items are placed and measured.
 */
export function assignItemsIncrementally(
  heights: number[],
  columnByIndex: number[],
  columnCount: number,
  gap: number,
) {
  const next = [...columnByIndex];
  const columnHeights = Array(columnCount).fill(0);

  for (let index = 0; index < next.length; index += 1) {
    const columnIndex = next[index];
    if (columnIndex === UNASSIGNED_COLUMN) continue;

    if (columnHeights[columnIndex] > 0) {
      columnHeights[columnIndex] += gap;
    }

    columnHeights[columnIndex] += heights[index];
  }

  for (let index = 0; index < heights.length; index += 1) {
    if (next[index] !== UNASSIGNED_COLUMN) continue;
    if (heights[index] <= 0) break;

    let shortestColumnIndex = 0;

    for (let columnIndex = 1; columnIndex < columnCount; columnIndex += 1) {
      if (columnHeights[columnIndex] < columnHeights[shortestColumnIndex]) {
        shortestColumnIndex = columnIndex;
      }
    }

    if (columnHeights[shortestColumnIndex] > 0) {
      columnHeights[shortestColumnIndex] += gap;
    }

    columnHeights[shortestColumnIndex] += heights[index];
    next[index] = shortestColumnIndex;
  }

  return next;
}

export function buildColumnGroups(columnByIndex: number[], columnCount: number) {
  const columns = Array.from({ length: columnCount }, () => [] as number[]);

  columnByIndex.forEach((columnIndex, itemIndex) => {
    const resolvedColumn =
      columnIndex === UNASSIGNED_COLUMN ? itemIndex % columnCount : columnIndex;
    columns[resolvedColumn].push(itemIndex);
  });

  return columns;
}
